import Tab from '../atoms/Tab';
import '../../styles/Styles.css';

const TabNavigation = ({ activeTab, setActiveTab }) => (
    <div className="tab-navigation">
         {/*<Tab
            label="Get Outlook-Email Settings"
            onClick={() => setActiveTab('Screen1')}
            isActive={activeTab === 'Screen1'}
        />
       <Tab
            label="Check Email"
            onClick={() => setActiveTab('Screen2')}
            isActive={activeTab === 'Screen2'}
        />*/}
    </div>
);
export default TabNavigation;